import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSave,
  FaTimes,
  FaImage,
  FaBuilding,
} from "react-icons/fa";

import "./Company.css";
import { BASE_URL } from "../../Config/config";
export default function CompanyPartners() {
  const API = `${BASE_URL}/company_customers.php`;

  const [partners, setPartners] = useState([]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);

  const [form, setForm] = useState({
    name: "",
    image: null,
  });

  /* =====================================================
     FETCH
  ===================================================== */

  const fetchPartners = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API}?action=get`);

      const text = await response.text();

      console.log("COMPANY PARTNERS:", text);

      const result = JSON.parse(text);

      if (result.status) {
        setPartners(Array.isArray(result.data) ? result.data : []);
      } else {
        alert(result.message || "Failed to fetch company partners.");
      }
    } catch (error) {
      console.error(error);

      alert("Unable to connect with company partner backend.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  /* =====================================================
     IMAGE URL
  ===================================================== */

  const getImageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http://") || image.startsWith("https://")) {
      return image;
    }

    return `${BASE_URL}/${image.replace(/^\/+/, "")}`;
  };

  /* =====================================================
     OPEN ADD
  ===================================================== */

  const openAdd = () => {
    setEditingPartner(null);

    setForm({
      name: "",
      image: null,
    });

    setShowForm(true);
  };

  /* =====================================================
     OPEN EDIT
  ===================================================== */

  const openEdit = (partner) => {
    setEditingPartner(partner);

    setForm({
      name: partner.name || "",
      image: null,
    });

    setShowForm(true);
  };

  /* =====================================================
     CLOSE
  ===================================================== */

  const closeForm = () => {
    setShowForm(false);
    setEditingPartner(null);

    setForm({
      name: "",
      image: null,
    });
  };

  /* =====================================================
     INPUT
  ===================================================== */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =====================================================
     IMAGE
  ===================================================== */

  const handleImageChange = (e) => {
    const file = e.target.files?.[0] || null;

    setForm((prev) => ({
      ...prev,
      image: file,
    }));
  };

  /* =====================================================
     SAVE
  ===================================================== */

  const savePartner = async () => {
    if (!form.name.trim()) {
      alert("Company name is required.");
      return;
    }

    if (!editingPartner && !form.image) {
      alert("Company logo is required.");
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();

      formData.append("name", form.name.trim());

      if (form.image) {
        formData.append("image", form.image);
      }

      let action = "add";

      if (editingPartner) {
        action = "update";

        formData.append("id", editingPartner.id);
      }

      const response = await fetch(`${API}?action=${action}`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      console.log("SAVE PARTNER:", result);

      if (!result.status) {
        alert(result.message || "Failed to save company partner.");
        return;
      }

      alert(
        editingPartner
          ? "Company partner updated successfully."
          : "Company partner added successfully.",
      );

      await fetchPartners();

      closeForm();
    } catch (error) {
      console.error(error);

      alert("Unable to save company partner.");
    } finally {
      setSaving(false);
    }
  };

  /* =====================================================
     DELETE
  ===================================================== */

  const deletePartner = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this company partner?",
    );

    if (!confirmed) return;

    try {
      const formData = new FormData();

      formData.append("id", id);

      const response = await fetch(`${API}?action=delete`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (!result.status) {
        alert(result.message || "Failed to delete company partner.");
        return;
      }

      alert("Company partner deleted successfully.");

      await fetchPartners();
    } catch (error) {
      console.error(error);

      alert("Unable to delete company partner.");
    }
  };

  /* =====================================================
     PREVIEW
  ===================================================== */

  const imagePreview = form.image ? URL.createObjectURL(form.image) : null;

  /* =====================================================
     RETURN
  ===================================================== */

  return (
    <div className="admin-company-page">
      {/* HEADER */}

      <div className="admin-company-header">
        <div>
          <span className="admin-company-label">TECHNOLOGY CLIENTS</span>

          <h1>Company Clients</h1>

          <p>Manage the technology Clients logos displayed on the website.</p>
        </div>

        <button
          type="button"
          className="admin-company-add-btn"
          onClick={openAdd}
        >
          <FaPlus />
          Add New
        </button>
      </div>

      {/* SUMMARY */}

      <div className="admin-company-summary">
        <div className="admin-company-summary-card">
          <div className="admin-company-summary-icon">
            <FaBuilding />
          </div>

          <div>
            <span>Total Clients</span>
            <strong>{partners.length}</strong>
          </div>
        </div>
      </div>

      {/* LIST */}

      <div className="admin-company-section">
        <div className="admin-company-section-heading">
          <div>
            <span>CLIENTS LIST</span>

            <h2>Manage Technology Clients</h2>
          </div>

          <strong>
            {partners.length} {partners.length === 1 ? "Client" : "Clients"}
          </strong>
        </div>

        {loading ? (
          <div className="admin-company-empty">
            <FaBuilding />

            <h3>Loading Clients...</h3>

            <p>Please wait while Clients are being loaded.</p>
          </div>
        ) : partners.length === 0 ? (
          <div className="admin-company-empty">
            <FaImage />

            <h3>No Clients Added</h3>

            <p>Add your technology Clients to display them on the website.</p>

            <button type="button" onClick={openAdd}>
              <FaPlus />
              Add First Client
            </button>
          </div>
        ) : (
          <div className="admin-company-grid">
            {partners.map((partner) => (
              <div className="admin-company-card" key={partner.id}>
                <div className="admin-company-image">
                  <img src={getImageUrl(partner.image)} alt={partner.name} />
                </div>

                <div className="admin-company-content">
                  <h3>{partner.name}</h3>
                </div>

                <div className="admin-company-actions">
                  <button type="button" onClick={() => openEdit(partner)}>
                    <FaEdit />
                    Edit
                  </button>

                  <button
                    type="button"
                    className="danger"
                    onClick={() => deletePartner(partner.id)}
                  >
                    <FaTrash />
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL */}

      {showForm && (
        <div className="admin-company-overlay">
          <div className="admin-company-modal">
            <div className="admin-company-modal-header">
              <div>
                <span>TECHNOLOGY CLIENT</span>

                <h2>{editingPartner ? "Edit " : "Add "}</h2>
              </div>

              <button type="button" onClick={closeForm}>
                <FaTimes />
              </button>
            </div>

            <div className="admin-company-form">
              {/* NAME */}

              <label>
                Company Name
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Tally"
                />
              </label>

              {/* IMAGE */}

              <label>
                Company Logo
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
                  onChange={handleImageChange}
                />
              </label>

              {/* CURRENT IMAGE */}

              {editingPartner && !form.image && editingPartner.image && (
                <div className="admin-company-preview">
                  <img
                    src={getImageUrl(editingPartner.image)}
                    alt="Current logo"
                  />

                  <span>Current logo</span>
                </div>
              )}

              {/* NEW IMAGE */}

              {imagePreview && (
                <div className="admin-company-preview">
                  <img src={imagePreview} alt="Preview" />

                  <span>New logo selected</span>
                </div>
              )}

              {/* SAVE */}

              <button
                type="button"
                className="admin-company-save-btn"
                onClick={savePartner}
                disabled={saving}
              >
                <FaSave />

                {saving ? "Saving..." : editingPartner ? "Update " : "Save "}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
